/* eslint-disable no-undef */
/**
 * @NOTE
 * Quick idea
 * Create adapter for WP host application with the following methods:
 *
 * bca - box configuration app
 */
import { createFetch } from "@vueuse/core";
import { getToken } from '@/utils/auth'

function Adapter (host) {
  const API_URL = host || process.env.VUE_APP_NODE_API
  if (!API_URL) {
    console.error('VUE_APP_NODE_API is not defined')
  }
  const CONFIGURATIONS = 'configurations'
  // const CONFIGURATION_ENDPOINT = `${API_URL}/${CONFIGURATIONS}`
  const FILES = 'files'

  // const Authorization = `Bearer ${getToken()}`

  const Client = createFetch({
    baseUrl: API_URL,
    options: {
      async beforeFetch({options}) {
        return { options }
      }
    }
  })

  // ---------------------------------------------------------------------------
  this.getConfiguration = () => {
    if ('BIC' in window) {
      return window.BIC
    }

    return {}
  }

  this.getConfigurations = async () => {
    try {
      const { data } = await Client(CONFIGURATIONS).json()

      const { data: configuration } = data.value || {}

      return configuration
    } catch (error) {
      console.error(error)
    }
  }

  this.getConfigurationById = async (id) => {
    try {
      const { data } = await Client(`${CONFIGURATIONS}/${id}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`
        },

      }).json()

      const { data: configuration } = data.value || {}

      return configuration
    } catch (error) {
      console.error(error)
    }
  }

  this.saveConfiguration = async (_configuration) => {
    try {
      const { data } = await Client(CONFIGURATIONS, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`
        },
        body: JSON.stringify(_configuration),
      }).json()

      const { data: configuration } = data.value || {}

      return configuration
    } catch (error) {
      console.error(error);
    }
  }

  this.updateConfiguration = async (id, _configuration) => {
    try {
      const { data } = await Client(`${CONFIGURATIONS}/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`
        },
        body: JSON.stringify(_configuration),
      }).json()

      const { data: configuration } = data.value || {}

      return configuration
    } catch (error) {
      console.error(error);
    }
  }

  this.deleteConfiguration = async (id) => {
    try {
      const response = await Client(`${CONFIGURATIONS}/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }).json()

      return response
    } catch (error) {
      console.error(error);
    }
  }

  /**
   *
   * @param {FormData} formData
   * @param {string} id
   * @returns configuration
   */
  this.saveScreenshot = async (formData, id) => {
    try {
      const { data } = await Client(`screenshot/${id}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getToken()}`
        },
        body: formData
      }).json()

      const { data: res } = data.value || {}

      return res
    } catch (error) {
      console.error(error);
    }
  }

  // ---------------------------------------------------------------------------
  this.getImages = async (limit = 10, skip) => {
    const queryParams = `?limit=${limit}${skip ? `&skip=${skip}` : ''}`;

    const url = `${FILES}${queryParams}`

    try {
      const { data: { value = {}} } = await Client(url, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`
        }
      }).json()
      const { data = [], page, total_count = 0 } = value

      return { data, page ,total_count }
    } catch (error) {
      console.error(error)
    }
  }

  this.uploadImage = async (formData) => {
    try {
      const { data } = await Client(`${FILES}/upload`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getToken()}`
        },
        body: formData
      }).json()

      return data
    } catch (error) {
      console.error(error)
      throw new Error(error)
    }
  }

  this.uploadUnsplashImage = async (url) => {
    try {
      const { data: { value = {}} } = await Client(`${FILES}/remote?url=${url}`, {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }).json()
      const { data } = value
      return data
    } catch (error) {
      console.error(error)
      throw new Error(error)
    }
  }

  this.deleteImage = async (id) => {
    try {
      await Client(`${FILES}/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }).json()

      return { success: true }
    } catch (error) {
      console.error(error)
    }
  }

  return this
}

export default Adapter
